import { ref, watch } from 'vue'

// Card/tree mode of the projects list. Module-scope so the switch in the
// panel header (App.vue) and the list itself (ProjectList.vue) share it.
const view = ref(localStorage.getItem('projectListView') === 'tree' ? 'tree' : 'cards')

watch(view, (value) => localStorage.setItem('projectListView', value))

export const useProjectListView = () => ({ view })
